<template>
  <div class="animated fadeIn">
    <b-form-group
      label="Email Addresses"
      :label-cols="3"
      class="mb-3"
      :state="!$v.form_data.emails.$dirty ? null : !$v.form_data.emails.$error"
    >
      <div v-for="(v, index) in $v.form_data.emails.$each.$iter" :key="index" class="mb-2">
        <div class="d-flex align-items-center">
          <b-form-input
            v-model.trim="v.value.$model"
            type="email"
            placeholder="email@example.com"
            class="mr-2"
            :state="!v.value.$dirty ? null : !v.value.$error"
          />
          <b-button
            variant="danger"
            @click="removeEmailField(index)"
            :disabled="form_data.emails.length <= 1"
          >
            <i class="fa fa-trash" />
          </b-button>
        </div>
        <b-form-invalid-feedback v-if="v.value.$dirty && !v.value.required">
          Email address is required.
        </b-form-invalid-feedback>
        <b-form-invalid-feedback v-else-if="v.value.$dirty && !v.value.email">
          Please enter a valid email address.
        </b-form-invalid-feedback>
      </div>
      <b-form-invalid-feedback v-if="$v.form_data.emails.$dirty && $v.form_data.emails.$error">
        At least one email address is required.
      </b-form-invalid-feedback>
      <b-button variant="success" @click="addEmailField" class="mt-2">
        <i class="fa fa-plus" /> Add Email
      </b-button>
    </b-form-group>

    <b-row v-if="validationError">
      <b-col>
        <b-alert variant="danger" show>
          <i class="fa fa-exclamation-triangle" /> Please fill out all required fields.
        </b-alert>
      </b-col>
    </b-row>

    <b-row v-if="error">
      <b-col>
        <b-alert variant="danger" show>
          <i class="fa fa-exclamation-triangle" /> {{ error }}
        </b-alert>
      </b-col>
    </b-row>

    <div class="clearfix mb-5">
      <b-button variant="success" class="float-right" :disabled="submittingForm" @click="onSubmit">
        <i v-if="submittingForm" class="fal fa-spinner fa-spin"></i>
        <span v-else>Save</span>
      </b-button>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email, minLength } from 'vuelidate/lib/validators'

export default {
  name: 'ResultEmailForm',
  mixins: [validationMixin],
  props: {
    submittingForm: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      form_data: {
        emails: [{ value: '' }]
      },

      validationError: false
    }
  },
  validations: {
    form_data: {
      emails: {
        required,
        minLength: minLength(1),
        $each: {
          value: {
            required,
            email
          }
        }
      }
    }
  },
  methods: {
    addEmailField() {
      this.form_data.emails.push({ value: '' })
    },
    removeEmailField(index) {
      this.form_data.emails.splice(index, 1)
    },
    onSubmit() {
      this.validationError = false
      this.$v.$touch()

      const validEmails = this.form_data.emails.filter((email, index) => {
        const emailValidator = this.$v.form_data.emails.$each[index]
        return email.value && email.value.trim() !== '' && !emailValidator.value.$error
      })

      if (validEmails.length > 0 && this.form_data.emails.length > 1) {
        const nonEmptyEmails = this.form_data.emails.filter(email =>
          email.value && email.value.trim() !== ''
        )

        if (nonEmptyEmails.length > 0) {
          this.$emit('submit', {
            emails: nonEmptyEmails.map(email => email.value)
          })
          return
        }
      }

      if (this.$v.$invalid) {
        this.validationError = true
        return
      }

      this.$emit('submit', {
        emails: this.form_data.emails.map(email => email.value)
      })
    }
  }
}
</script>
